import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "$", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "$", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" US First ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "$", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" US Addition ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "$", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ROW First ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "$", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" ROW Addition ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "$", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_close_button = _resolveComponent("close-button")!
  const _component_save_button = _resolveComponent("save-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: _ctx.title,
    width: "45%"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_close_button, {
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onClose()))
      }),
      _createVNode(_component_save_button, {
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSave()))
      })
    ]),
    default: _withCtx(() => [
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            ref: "form",
            model: _ctx.variant,
            rules: _ctx.rules,
            "label-width": "20%"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Variant code",
                prop: "catalogVariantCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.variant.catalogVariantCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.variant.catalogVariantCode) = $event)),
                    clearable: "",
                    maxlength: 60,
                    "show-word-limit": "",
                    placeholder: "Enter variant code"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Status",
                prop: "inStock"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.variant.inStock,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.variant.inStock) = $event)),
                    placeholder: "Select stock status",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "In Stock",
                        value: true
                      }),
                      _createVNode(_component_el_option, {
                        label: "Out of Stock",
                        value: false
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Designs",
                prop: "designs"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.variant.designs,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.variant.designs) = $event)),
                    class: "w-full",
                    multiple: "",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.designs, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.name,
                          label: item.name,
                          value: item.name
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Design cost",
                prop: "designCost"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.variant.designCost,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.variant.designCost) = $event)),
                    autocomplete: "off",
                    type: "number"
                  }, {
                    prefix: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Cost",
                prop: "cost"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.variant.cost,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.variant.cost) = $event)),
                    autocomplete: "off",
                    type: "number",
                    clearable: ""
                  }, {
                    prefix: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Shipping" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        md: 10,
                        class: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3,
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.variant.shipUsFirst,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.variant.shipUsFirst) = $event)),
                            autocomplete: "off",
                            type: "number"
                          }, {
                            prefix: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        md: 10,
                        class: "mx-5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5,
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.variant.shipUsAdditional,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.variant.shipUsAdditional) = $event)),
                            autocomplete: "off",
                            type: "number"
                          }, {
                            prefix: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { class: "my-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        md: 10,
                        class: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.variant.shipRowFirst,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.variant.shipRowFirst) = $event)),
                            autocomplete: "off",
                            type: "number"
                          }, {
                            prefix: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        md: 10,
                        class: "mx-5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.variant.shipRowAdditional,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.variant.shipRowAdditional) = $event)),
                            autocomplete: "off",
                            type: "number"
                          }, {
                            prefix: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}